import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class CorporationZoneService {
  is_display_corporation_zone_register_component = false;
  CorporationZoneUpdate = new EventEmitter<ZONE>();

  downloadCorporationZone = new EventEmitter<boolean>();

  private _corporation_zone_data: CORPORATIONZONE = null;

  constructor() {
   }

  set set_corporation_zone_data(relation_type) {
    this._corporation_zone_data = relation_type;
  }

  get get_corporation_zone_data() {
    return this._corporation_zone_data;
  }
}

export interface CORPORATIONZONE {
  id: number;
  name: string;
}
